module.exports = __webpack_public_path__ + "img/32.72b3b68d.jpg";